<footer class="footer footer-black footer-white">
  <div class="container-fluid">
    <div class="row">
      <div class="credits ml-auto">
        <span class="copyright"> © {{ anoAtual }} ELETRONORTE </span>
      </div>
    </div>
  </div>
</footer>
